/**
 * Видеоотзывы клиентов — перенесены со страницы /reviews/ боевого сайта
 * (снято 28.08.2026, шесть роликов, порядок и подписи как на проде).
 *
 * Идентификаторы и имена не выдумываются: и то и другое взято с продовой
 * страницы, где ролики уже опубликованы. Ролик без подписи не добавляется —
 * подпись здесь и есть имя реального человека.
 *
 * Встраивание идёт через youtube-nocookie.com: обычный домен ставит рекламные
 * cookie до того, как посетитель нажал play.
 */
export interface VideoTestimonial {
  /** Идентификатор ролика на YouTube. */
  id: string;
  /** Подпись под роликом — как на проде. */
  name: string;
}

export const videoTestimonials: VideoTestimonial[] = [
  { id: 'Ii6gEHXtyzg', name: 'Gozkaman, Marina' },
  { id: 'ZGC82qmx4Ms', name: 'Cherbakov, Michael' },
  { id: 'WRUdseQ1YUk', name: 'Katz, Janice' },
  { id: 'xXzSrwckve8', name: 'Millin, Everton' },
  { id: 'OQjmNonIlic', name: 'Michelle Renee Ford' },
  { id: 'W__sO7P7jfM', name: 'Damaris Peralta-Hernandez' },
];
